import {
	Box,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import React from "react";
import { TERMS } from "../../../../config/terminology";
import { sizes } from "../scenarioSetupNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./editScenarioNewSlice";
import { useEffect } from "react";

const commonHeight = sizes.h35;
const SW = sizes.w300;

export default function DefineScenarioSettings() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.editScenarioNew);
	const {
		minimumQuota,
		editScDetails,
		criticalityList,
		criticalityId,
	} = setupState;

	useEffect(() => {
		if (editScDetails !== null) {
			// dispatch(setState("minimumQuota", editScDetails.minimumQuota));
			// dispatch(setState("skuBreakdown", editScDetails.skuBreakdown));
			// dispatch(setState("selectedScSTQ", "Enabled"));
		}
	}, [editScDetails]);

	const handleStateUpdate = (event, stateName) => {
		const value = event.target.value;
		dispatch(setState(stateName, value));
	};

	useEffect(() => {
		if (
			criticalityList?.length > 0 &&
			(criticalityId === "" || criticalityId === 0 || criticalityId == null)
		) {
			const lowCriticality = criticalityList.find(
				(c) => c.scenarioCriticalityDesc?.toLowerCase() === "low"
			);
			if (lowCriticality) {
				dispatch(setState("criticalityId", lowCriticality.scenarioCriticalityID));
			}
		}
	}, [criticalityList, criticalityId, dispatch]);

	return (
		<Box sx={{ mt: 4, }} >
			{/* <hr style={{
     border: ".25px solid #c6c6c6",
    }}/> */}
			{/* <Typography sx={{ color: "lightBlue.main", fontWeight: "700", marginBottom: 2, mt: 3, }} className="compHeading">
					Define Scenario Settings
				</Typography> */}

			<Box sx={{ mt: 4, }}>
				<Grid container spacing={2} columns={12} alignContent={"space-between"}>
					<Grid item sm={6} md={6} xs={6} lg={6} sx={{ display: "none" }}>
						<Box>
							<TextField sx={{
								width: "100%"
							}}
								type={"number"}
								id="outlined-basic"
								label="Minimum Allocation Value"
								variant="outlined"
								size="small"
								value={minimumQuota}
								onChange={(event) => {
									const inputValue = parseFloat(event.target.value);
									if (isNaN(inputValue) || inputValue >= 0) {
										handleStateUpdate(event, "minimumQuota")
									}
								}}
								InputProps={{ autoComplete: "off" }}
							/>
						</Box>
					</Grid>


					<Grid item sm={6} md={6} xs={6} lg={6} sx={{ display: "none" }}>
						<Box>
							<FormControl sx={{ width: "100%", }}>
								<InputLabel id="demo-simple-select-label">
									Scenario Criticality
								</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={criticalityId}
									label="Scenario Criticality"
									sx={{
										height: commonHeight,
										width: SW,
										color: "black.main",
										mt: 1,
									}}
									onChange={(event) =>
										handleStateUpdate(event, "criticalityId")
									}
								>
									{criticalityList?.map((source, index) => {
										return (
											<MenuItem key={index} value={source.scenarioCriticalityID}>
												{source.scenarioCriticalityDesc}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Box>
					</Grid>

					{/* <Grid item sm={6} md={3} lg={3}>
						<Box>
							<FormControl sx={{width: "100%",}}>
								<InputLabel id="demo-simple-select-label">
									{`Scenario Stick to ${TERMS.QUOTA}`}
								</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={selectedScSTQ}
									label={`Scenario Stick to ${TERMS.QUOTA}`}
									sx={{
										height: commonHeight,
										width: SW,
										color: "black.main",
										mt: 1,
									}}
									onChange={(event) =>
										handleStateUpdate(event, "selectedScSTQ")
									}
								>
									{scenarioSTQ.map((item, index) => {
										return (
											<MenuItem key={index} value={item.value}>
												{item.value}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Box>
					</Grid> */}
				</Grid>
			</Box>
		</Box>
	);
}
